import { SVGProps } from 'react';

export type IconProps = SVGProps<SVGSVGElement> & {
    bgColor?: string;
};
export const defaultProps: IconProps = { height: 24, width: 24 };

export const defaultTextClass = 'text-secondary';
export const defaultTextLightClass = 'text-[#6F7FE7]';
